import {Button, Dropdown, DropdownItem, DropdownSearchItem} from 'platform/components';
import {HStack, Text} from 'platform/foundation';

import {useState} from 'react';

import {filter, includes, toUpper} from 'ramda';

import i18n from '@dms/i18n';

import {Nullish, suffixTestId, TestIdProps, useBoolean} from 'shared/web';

interface BranchSelectOption {
  value: string;
  label: string | Nullish;
}

interface PersonnelOverviewBranchSelectProps extends TestIdProps {
  value: string;
  options: BranchSelectOption[];
  onChange: (value: string) => void;
}
export function PersonnelOverviewBranchSelect(props: PersonnelOverviewBranchSelectProps) {
  const [isDropdownOpen, openDropdown, closeDropdown] = useBoolean();
  const [searchQuery, setSearchQuery] = useState<string | Nullish>(null);

  const filteredOptions = !searchQuery
    ? props.options
    : filter(
        (option) => includes(toUpper(searchQuery), toUpper(option.label ?? '')),
        props.options
      );

  const selectedOption = props.options.find((opt) => opt.value === props.value);

  const displayLabel = selectedOption?.label ?? '';

  const handleClose = () => {
    setSearchQuery(null);
    closeDropdown();
  };

  return (
    <HStack spacing={1} align="center">
      <Text size="small" color="secondary">
        {i18n.t('entity.branch.labels.branch')}:
      </Text>

      <Dropdown
        isOpen={isDropdownOpen}
        onOpen={openDropdown}
        onClose={handleClose}
        placement="bottom-start"
        hasSearch
        isHeightLimited
        dropdownControl={
          <Button
            variant="ghost"
            size="small"
            title={displayLabel}
            aria-label={displayLabel}
            onClick={openDropdown}
            rightIcon={isDropdownOpen ? 'navigation/arrow_drop_up' : 'navigation/arrow_drop_down'}
            data-testid={suffixTestId('branchSelect', props)}
          />
        }
        data-testid={suffixTestId('branchSelect', props)}
      >
        <DropdownSearchItem
          value={searchQuery ?? null}
          onChange={setSearchQuery}
          data-testid={suffixTestId('branchSelect-search', props)}
        />
        {filteredOptions.map((option) => (
          <DropdownItem
            key={option.value}
            label={option.label ?? ''}
            onClick={() => {
              props.onChange(option.value);
              handleClose();
            }}
            data-testid={suffixTestId(`branchSelect-${option.value}`, props)}
          />
        ))}
      </Dropdown>
    </HStack>
  );
}
